// Reordering of the product tabs on /admin/products.
import Sortable from 'sortablejs'

$(document).on('turbolinks:load', function() {
  let tbody = document.querySelector('tbody.sortable');
  if (tbody === null) { return; }

  // Turbolinks restores cached pages, so drop a previous instance first.
  if (tbody.sortableInstance) { tbody.sortableInstance.destroy(); }

  tbody.sortableInstance = Sortable.create(tbody, {
    animation: 150,
    draggable: 'tr',
    ghostClass: 'dragging',
    // The whole row drags, except where it carries actions.
    filter: 'td.not-selectable, .btn',
    preventOnFilter: false,
    onEnd: function() {
      renumber(tbody);
      persist(tbody);
    }
  });
});

// The first column shows the position, so it has to follow the new order.
function renumber(tbody) {
  $(tbody).find('tr').each(function(index) {
    $(this).find('td.drag-handle').text(index + 1);
  });
}

function persist(tbody) {
  let ids = $(tbody).find('tr').map(function() { return $(this).data('id'); }).get();

  $.ajax({
    type: 'POST',
    url: $(tbody).data('sort-url'),
    data: { ids: ids },
    // @rails/ujs does not patch jQuery's ajax, so the token goes out by hand.
    headers: { 'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content') }
  });
}
